// Todo: Expand this enum to include all models that are presented to the user (to reduce and normalise translation patterns).
export enum ModelName {
  Investigation = 'Investigation',
}

// Note: It might be a little verbose to enumerate 24 hours, but this makes it very easy to reuse existing filter logic patterns.
export enum Hours {
  AM12 = '0',
  AM1 = '1',
  AM2 = '2',
  AM3 = '3',
  AM4 = '4',
  AM5 = '5',
  AM6 = '6',
  AM7 = '7',
  AM8 = '8',
  AM9 = '9',
  AM10 = '10',
  AM11 = '11',
  PM12 = '12',
  PM1 = '13',
  PM2 = '14',
  PM3 = '15',
  PM4 = '16',
  PM5 = '17',
  PM6 = '18',
  PM7 = '19',
  PM8 = '20',
  PM9 = '21',
  PM10 = '22',
  PM11 = '23',
}
